<template>
    <div class="p-10 w-full bg-grayBg rounded-3xl text-black">
        <h2 class="mb-[30px] text-2xl font-medium">
            Богатая палитра цветов
        </h2>
        <div class="flex items-start ">
            <div class="grid grid-cols-5 sm:grid-cols-10 md:grid-cols-7 lg:grid-cols-10 gap-3 w-full">
                <ColorChoiceItem v-for="color in colors"
                                 :key="color.id"
                                 :hex="color.hex"
                                 :title="color.title"
                                 :id="color.id"/>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import ColorChoiceItem from "@js/components/Sections/Home/Components/ColorChoiceItem.vue";

export default {
    name: "ColorChoice",
    components: {ColorChoiceItem},
    data() {
        return {
            is_loading: true,
            colors: [],
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            if (this.colors.length > 0) return;

            this.is_loading = true;
            axios
                .post("/axios/popular/colors")
                .then(({data}) => {
                    this.colors = data;
                })
                .finally(() => {
                    this.is_loading = false;
                });
        },
    },
};
</script>

<style scoped>
/* ничего больше не нужно */
</style>
